<template>
  <div id="PromoterHome">
    <Background-Image url="/woman-woods.jpg"color="#000"></Background-Image>
    <Navigation hideLogo='true' backgroundColor="transparent"></Navigation>
    <div class="container-fluid intro">
      <div class="row">
        <div class="col-md-6 sameHeight">
          <router-link class="brand m-t-3" :to="'/'+this.$store.state.language">booknatura</router-link>
          <h2>{{t('A booking platform')}}</h2>
          <h2>{{t('for nature activities')}}</h2>
          <ul class="whyWeMatter m-t-4">
            <li>{{t('Search by activity, location or date')}}</li>
            <li>{{t('Allows easy and fast bookings')}}</li>
            <li>{{t('Accepts multiple payment methods')}}</li>
          </ul>
        </div>
        <div class="col-md-6 sameHeight mainActions text-sm-right">
          <div class="primaryAction">
            <router-link class="btn btn-primary m-b-1" :to="'/'+this.$store.state.language+'/supplier/register'">{{t('Supplier Registration')}}</router-link>
          </div>
          <div class="secundaryAction">
            <router-link class="btn btn-primary" :to="'/'+this.$store.state.language+'/login'">{{t('Login')}}</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="details">
      <div class="container-fluid m-t-5">
        <div class="row">
          <div class="col-md-4 m-b-4">
            <h4>{{t('Increase your Bookings')}}</h4>
            <ul>
              <li>{{t('Higher visibility for your activities in the national and international market')}}</li>
              <li>{{t('Enables instant confirmation of bookings')}}</li>
              <li>{{t('Ensure a flawless experience for your customers')}}</li>
            </ul>
          </div>
          <div class="col-md-4 m-b-4">
            <h4>{{t('Save time and money')}}</h4>
            <ul>
              <li>
                {{t('Free access to management software')}}<br/>
                <ul>
                  <li>
                    {{t('Simple management of your bookings through your computer or smartphone')}}
                  </li>
                  <li>
                    {{t('Add or edit your activities whenever necessary')}}
                  </li>
                </ul>
              </li>
              <li>
                {{t('No fees or subscription')}}
                <ul>
                  <li>{{t('Pay only a commission for bookings made through the platform')}}</li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="col-md-4 m-b-4">
            <h4>{{t('Share our vision')}}</h4>
            <p>
              {{t('We believe that all those who practice or organize tourism activities in nature should promote respect for the natural heritage and contribute to its conservation.')}}
            </p>
            <p>
              {{t('Booknatura is designed to clients who enjoy contact with nature and seek more active, authentic and sustainable experiences.')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="finale">
      <div class="container-fluid">
        <div class="roW">
          <div class="col-lg-4 col-md-12 col-sm-12">
            <h2>{{t('Join us')}}</h2>
            <div class="secActionButtons">
              <router-link class="btn btn-primary" :to="'/'+this.$store.state.language+'/supplier/register'">{{t('Supplier Registration')}}</router-link>
              <p class="or"><small>{{t('or')}}</small></p>
              <a href="mailto:info@booknatura.com" class="btn btn-primary btn-sm btn-contact">{{t('contact us')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import Navigation from '../Navigation/Navigation';
  import BackgroundImage from '../BackgroundImage';
import MatchHeight from 'jquery-match-height'; // eslint-disable-line

const $ = window.$;

export default {
    name: 'PromoterHome',
    components: {
      Navigation,
      'Background-Image': BackgroundImage,
    },
    mounted() {
      $('.sameHeight').matchHeight();
      if (this.$store.state.user.data.type === 'promoter') {
        this.$router.push(`/${this.$store.state.language}/supplier/dashboard`);
      }
    },
    data() {
      return {};
    },
};
</script>

<style lang="scss" scoped>
  #PromoterHome {
    min-height: 100vh
  }

  .intro {
  min-height: 60vh; /*74vh*/
}
.brand {
  background: url('../../../static/img/logo-booknatura-white.svg') no-repeat left center;
  background-size: contain;
  font-size: 0;
  text-indent: -9999px;
  display: block;
  width: 60%;
  height: 100px;
  margin-bottom: 38px;
  margin-top: 6px;
}
.intro h2 {
  font-size: 2.1rem;
  color: white;
  font-weight: 100;
  line-height: 1;
  letter-spacing: 1px;
}

.whyWeMatter {
  color: white;
  font-size: 1rem;
  li {
    margin-bottom: 0.6em;
  }
}
.mainActions {
  padding-top: 43vh;
  .btn {
    min-width: 13em;
  }
}
.details {
  padding-top: 15vh;
  padding-bottom: 30vh;
      /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+30,000000+70,000000+100&0+0,0.6+30,0.6+70,0+100 */
      background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 30%, rgba(0,0,0,0.6) 70%, rgba(0,0,0,0) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.6) 30%,rgba(0,0,0,0.6) 70%,rgba(0,0,0,0) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.6) 30%,rgba(0,0,0,0.6) 70%,rgba(0,0,0,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#00000000',GradientType=0 ); /* IE6-9 */
        // background: red;
        color: white;

        h4 {
          margin-top: 0.5em;
          font-size: 1.5rem;
          letter-spacing: 0.02em;
          padding-bottom: 0.6em;
          margin-left: 0.7em;
          border-bottom: 1px solid #00B48D;
          margin-bottom: 0.5em;
          line-height: 1.5;
        }

        ul li {
          font-weight: 500;
          li {
            font-weight: 200;
          }
        }
        ul ul {
          margin-top: 12px;
        }
        ul ul li:before {
          content: none;

        }
        li {
          line-height: 1.5;
          margin-bottom: 12px;
          padding-left: 1em;
          font-size: 16px;
        }
        li::before {
          content: "• ";
          color: #00B48D;
          display: inline-block;
          padding-right: 0.5em;
          margin-left: -1em;
        }
        p {
          padding-left: 1em;
          font-size: 16px;
        }
      }
      .finale {
        min-height: 60vh;
        color: white;
        text-align: center;

        .secActionButtons {
          margin-top: 50px;
        }
        a, p {
          margin-bottom: 6px;
        }
        .btn-sm {
          font-size: 12px;
        }
        .btn-contact {
          background: transparent;
          border: 1px solid #00B48D;
        }
      }
    </style>



// WEBPACK FOOTER //
// PromoterHome.vue?00b2dada